import { Button, Grid, Paper } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { observer } from "mobx-react";
import { SnackbarProvider } from "notistack";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Content, Footer, Header, Breadcrumb, BreadcrumbPart, SideNav, TopNav, ActionBar } from "zebdsh.appframe";
import { StoreContext } from "../StoreContext";
import { globalTheme } from "../Theming";
import ActionWidget from "./ActionWidget";
import DatasetWidget from "./data/DatasetWidget";
import JobPanels from "./jobpanels/JobPanels";
import Notifier from "./Notifier";
import styled from "@emotion/styled";
const Styled_MainGrid = styled(Grid)(({ theme }) => ({
    minHeight: "calc(100vh - 8rem - 2rem - 3rem)", // 100vh - marginTop - marginBottom - var(--footer-height)
    margin: 0, // turn off negative margin due to spacing=1
    paddingRight: "8px", // compensate extra width due to spacing=1
}));
const Styled_SnackBarButton = styled(Button)(({ theme }) => ({
    fontSize: "1.4rem",
    color: "#fff",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: "transparent",
        border: "#fff 1px solid",
    },
}));
const Styled_ActionArea = styled(Paper)(({ theme }) => ({
    width: "100%",
    height: "100%",
    padding: "2rem",
}));
const Styled_ContentArea = styled("div")(({ theme }) => ({
    flexGrow: 1,
    width: "100%",
}));
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
    "&.SnackbarItem-variantSuccess": {
        fontSize: "1.4rem",
    },
    "&.SnackbarItem-variantError": {
        fontSize: "1.4rem",
    },
    "&.SnackbarItem-variantWarning": {
        fontSize: "1.4rem",
    },
    "&.SnackbarItem-variantInfo": {
        fontSize: "1.4rem",
    },
}));
export const AppWidget = observer((props) => {
    const [t, i18n] = useTranslation();
    const context = useContext(StoreContext);
    const removeEntry = (key) => {
        return () => context.rootStore.notificationStore.removeSnackbar(key);
    };
    const renderBreadcrumb = () => {
        let title = props.appModel.config.appName;
        if (props.appModel.custom.title) {
            let language = props.appModel.language;
            if (props.appModel.custom.title[language]) {
                title = props.appModel.custom.title[language];
            }
            else if (props.appModel.custom.title["default"]) {
                title = props.appModel.custom.title["default"];
            }
        }
        let labelEntry = {
            label: title,
            onClick: () => {
                window.location.hash = "";
            },
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(BreadcrumbPart, { appModel: props.appModel, entry: labelEntry }),
            context.rootStore.jobPanelStore.selectedEntry && (React.createElement(BreadcrumbPart, { appModel: props.appModel, entry: { label: context.rootStore.jobPanelStore.selectedEntry.name } }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { appModel: props.appModel },
            React.createElement(Breadcrumb, { appModel: props.appModel }, renderBreadcrumb()),
            React.createElement(SideNav, { appModel: props.appModel }),
            React.createElement(ActionBar, { appModel: props.appModel }),
            React.createElement(TopNav, { appModel: props.appModel })),
        React.createElement(Content, null,
            React.createElement(ThemeProvider, { theme: globalTheme },
                React.createElement(StyledSnackbarProvider, { maxSnack: 3, action: (key) => React.createElement(Styled_SnackBarButton, { onClick: removeEntry(key) }, t("translations:action close")) },
                    React.createElement(Notifier, null)),
                React.createElement("div", { style: { margin: "8rem 2rem 2rem 2rem" } },
                    React.createElement(Styled_MainGrid, { container: true, direction: "column", spacing: 1 },
                        React.createElement(Grid, { item: true, container: true, xs: 12 },
                            React.createElement(Styled_ActionArea, { elevation: 3, style: { padding: 0 } },
                                React.createElement(ActionWidget, { appModel: props.appModel }))),
                        React.createElement(Grid, { item: true, container: true, sx: { flexGrow: 1 }, xs: 12 },
                            React.createElement(Styled_ContentArea, null, context.rootStore.jobPanelStore.selectedEntry ? React.createElement(DatasetWidget, null) : React.createElement(JobPanels, null))))))),
        React.createElement(Footer, { appModel: props.appModel, fixedToBottom: false })));
});
